import styles from "./styles.module.scss";
import {
  FileIcon,
  EditIcon2,
  VirusIcon,
  LayersIcon,
  LineChartIcon,
  PieChartIcon,
} from "assets";

const Features = () => {
  const features: FeatureData[] = [
    {
      Icon: FileIcon,
      title: "Metrics Setter",
      description: `Enables recruiters to establish performance criteria for desired talent, encompassing various dimensions such as work culture, soft skills, personality traits, basic expectations, and technical proficiencies.`,
    },
    {
      Icon: VirusIcon,
      title: "Assessment Simulator",
      description:
        "Allows recruiters to create and distribute performance metrics through application links, facilitating the evaluation of potential candidates.",
    },
    {
      Icon: LayersIcon,
      title: "Candidate Assessment",
      description:
        "Provides candidates with an auto-generated assessment platform to demonstrate their competencies across predefined metrics.",
    },
    {
      Icon: EditIcon2,
      title: "Performance Filter",
      description:
        "Screens candidates based on their abilities against established performance metrics to identify suitable matches for the roles.",
    },
    {
      Icon: LineChartIcon,
      title: "Progress Tracking",
      description:
        "Monitor candidate progress, set timed assessments, and track their performance.",
    },
    {
      Icon: PieChartIcon,
      title: "Report Insights",
      description:
        "Delivers customized reports to the hiring team, offering insights into each candidate's competence and alignment with the specified criteria.",
    },
  ];
  return (
    <>
      <section className={`container ${styles.wrapper}`}>
        <h2 className={styles.ttl}>What’s included?</h2>
        <div data-aos="zoom-in" className={styles.features}>
          {features.map((item) => (
            <Feature {...item} key={item.title} />
          ))}
        </div>
      </section>
    </>
  );
};
interface FeatureData {
  Icon: React.FunctionComponent<
    React.SVGProps<SVGSVGElement> & {
      title?: string | undefined;
    }
  >;
  title: string;
  description: string;
}
const Feature: React.FC<FeatureData> = ({ Icon, title, description }) => {
  return (
    <div className={styles.feature}>
      <div className={styles.feature__icon}>
        <Icon />
      </div>
      <p className={styles.feature__ttl}>{title}</p>
      <p className={styles.feature__txt}>{description}</p>
    </div>
  );
};

export { Features };
